import { render, staticRenderFns } from "./AccountPagesGroup.vue?vue&type=template&id=16e6629a"
import script from "./AccountPagesGroup.vue?vue&type=script&lang=ts"
export * from "./AccountPagesGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports